export default {
  appTitle: 'Captin',
  apiUrl: 'https://api.captin.io/api',
  appEnv: 'production',
  isDevelopment: false,
  isStaging: false,
  isProduction: true,
};
